export { EventsPageBannerSection } from "./EventsPageBannerSection";
export { EventsPageContentSection } from "./EventsPageContentSection";
